module.exports = __webpack_public_path__ + "static/img/msactimg1.2e778cf.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/38act/msactimg1.png?v=1
// module id = gako
// module chunks = 1